<div 
 class="flex justify-start my-3 gap-6 font-semibold"
 [class.text-lrpTicketBlue]="active()"
 [class.text-gray-400]="!active()"
 [class.cursor-pointer]="!linear && !active"
 (click)="toggle.emit()">
    @if (numbered){
        <div 
        class="border border-gray-300 w-8 h-8 text-center rounded-full flex flex-col justify-center"
        [class.text-white]="active()"
        [class.bg-lrpTicketBlue]="active()"
        [class.border-lrpTicketBlue]="active()">
            {{ index$ | async }}
        </div>
    }
    <div class="h-8 flex flex-col justify-center tracking-wider" [class.font-bold]="active()">
        {{ header }}
    </div>
    @if (completed()){
        <fa-icon [icon]="['fas','check']" class="text-green-700" size="xl" />
    }
</div>
<div 
    class="ms-4 transition-all duration-500 ease-in-out"
    [class.overflow-hidden]="!active()"
    [style.max-height]="active() ? '100vh' : '0px'">
    <div class="px-10 border-l-2 border-gray-300">
        <ng-content></ng-content>
    </div>
</div>